// ============================================================
// Datei: src/hooks/useMediaQuery.js
// PURPOSE:
// Custom Hook für Media Queries (Desktop / Mobile Umschaltung)
// ============================================================

import { useEffect, useState } from "react";

/**
 * useMediaQuery
 * @param {string} query - CSS Media Query
 * @returns {boolean}
 */
const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(
        window.matchMedia(query).matches
    );

    useEffect(() => {
        const media = window.matchMedia(query);
        const listener = () => setMatches(media.matches);

        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }, [query]);

    return matches;
};

export default useMediaQuery;
